import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=1128256c&"
import script from "./DateInput.vue?vue&type=script&lang=js&"
export * from "./DateInput.vue?vue&type=script&lang=js&"
import style0 from "./DateInput.vue?vue&type=style&index=0&id=1128256c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports